import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { editorsPickQueries } from '@/services/editorsPick/editorsPick.queries';

export const useGetEditorsPickDetail = (editorPickId: string) => {
  const { data, isFetched, isLoading } = useQuery({
    ...editorsPickQueries.detail(editorPickId),
    enabled: !!editorPickId,
  });

  return {
    editorsPickDetail: data?.data,
    isFetched,
    isLoading,
  };
};

export default useGetEditorsPickDetail;
